import { render, staticRenderFns } from "./directInvest_HowItWorks.vue?vue&type=template&id=40940af8&scoped=true"
import script from "./directInvest_HowItWorks.vue?vue&type=script&lang=js"
export * from "./directInvest_HowItWorks.vue?vue&type=script&lang=js"
import style0 from "./directInvest_HowItWorks.vue?vue&type=style&index=0&id=40940af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40940af8",
  null
  
)

export default component.exports